import React, { useState } from "react";
import { Box, Button, Divider, Flex, HStack, Text, Textarea, VStack } from "@chakra-ui/react";
import { apiListComments, apiNewComment, apiDeleteComment, Comment } from "api/common/comment.service";
import { useQuery, useQueryClient } from "react-query";
import LocalSpinner from "components/LocalSpinner";
import { formatDate } from "utils";
import AvatarBadge from "./AvatarBadge";
import { Trash } from "@phosphor-icons/react";
import { colors } from "theme/foundations/colors";
import { bg } from "date-fns/locale";
import { useAuth } from "context";
/**
 * Figma: ??
 */
const CommentSection = ({ targetId, targetTable = "issb_question" }) => {
  const { data: comments, isLoading } = useQuery(["comments", targetId], () => apiListComments(targetTable, targetId), {
    enabled: !!targetId,
  });

  if (!targetId) {
    return null;
  }

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        {comments?.map((comment) => (
          <Box key={comment.id}>
            <SingleComment comment={comment} />
            <Divider mt={1} />
          </Box>
        ))}
        {isLoading && <LocalSpinner />}
        <ReplyBox targetId={targetId} targetTable={targetTable} />
      </VStack>
    </Box>
  );
};

const ReplyBox = ({ targetId, targetTable }) => {
  const queryClient = useQueryClient();
  const [commentText, setCommentText] = useState("");
  const handleAddComment = () => {
    if (!commentText.trim()) {
      return;
    }
    const comment = {
      targetId,
      targetTable,
      message: commentText,
    };
    apiNewComment(comment).then(() => {
      queryClient.invalidateQueries(["comments", targetId]);
      setCommentText("");
    });
  };
  return (
    <Flex direction="column" gap={4}>
      <Textarea value={commentText} focusBorderColor="lime" onChange={(e) => setCommentText(e.target.value)} />
      <Flex justify="flex-end">
        <Button variant="primary" onClick={handleAddComment} disabled={!commentText.trim()}>
          Add Comment
        </Button>
      </Flex>
    </Flex>
  );
};

/**
 * @param {Object} props
 * @param {Comment} props.comment
 */
const SingleComment = ({ comment }) => {
  const { user } = useAuth();
  const canDelete = user?.sub === comment?.createdBy;
  const queryClient = useQueryClient();
  const handleDelete = () => {
    apiDeleteComment(comment).then(() => {
      queryClient.invalidateQueries(["comments", comment.targetId]);
    });
  };
  return (
    <HStack align="start" spacing={3} borderColor="gray.200" py={4}>
      <VStack align="start" spacing={1} w="100%">
        {/* Avatar, Name, and Timestamp */}
        <HStack justify="space-between" w="100%">
          <HStack>
            <AvatarBadge user={comment.sender} size="sm" />
            <Text fontWeight="bold" fontSize="body.s" color="darkTeal">
              {comment.sender?.username}
            </Text>
          </HStack>
          <Text fontSize="body.xs" color="gray.500">
            {formatDate(comment.createdDate)}
          </Text>
        </HStack>

        <Text fontSize="body.s" color="gray.600">
          {commentFormatHACK(comment.message)}
        </Text>
        <Flex justify="flex-end" w="100%">
          {canDelete && (
            <Button
              variant="outline"
              title="Delete this comment"
              color={colors.esg_red}
              size={16}
              onClick={handleDelete}
            >
              <Trash />
            </Button>
          )}
        </Flex>
      </VStack>
    </HStack>
  );
};

function commentFormatHACK(message) {
  // TODO if we want to support @mentions
  return message;
}

export default CommentSection;
